import HeadBar from '../../header/Menu'

function Menu() {
  return (
    <HeadBar />
  )
}

export default Menu